import React from "react";
const numero = new Intl.NumberFormat("it-IT");
export const statisticsAxis = {
  axisLine: false, tickLine: false, tick: { fill: "#64748B", fontSize: 12 },
};
export const statisticsNumberAxis = { ...statisticsAxis, tickFormatter: value => numero.format(value) };
export const statisticsGrid = { vertical: false, stroke: "#E7EDF5", strokeDasharray: "3 4" };
export const statisticsTooltip = {
  cursor: { fill: "#EFF6FF", radius: 12 },
  formatter: (value, name) => [numero.format(value), name],
  contentStyle: { borderRadius: 12, border: "1px solid #DBEAFE", boxShadow: "0 10px 25px rgba(15,23,42,.10)" },
  labelStyle: { fontWeight: 600, color: "#1E293B", marginBottom: 6 },
};
export const StatisticsChart = ({ title, subtitle, children, count = 0 }) => (
  <section className="mt-4 w-full rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
    <h3 className="text-lg font-bold text-slate-800">{title}</h3>
    {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
    <div className="mt-4 overflow-x-auto">
      <div style={{ height: 360, width: `min(100%, ${Math.max(680, count * 180)}px)`, minWidth: Math.max(480, count * 65) }}>{children}</div>
    </div>
  </section>
);
